import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { getTenantSession, type TenantSession } from '@/lib/auth/tenant-auth';

const TenantContext = createContext<TenantSession | null>(null);

export function TenantAuthProvider({ children }: { children: ReactNode }) {
  const session = useMemo(() => getTenantSession(), []);
  return <TenantContext.Provider value={session}>{children}</TenantContext.Provider>;
}

export function useTenantContext(): TenantSession {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenantContext requires an active tenant session');
  }
  return context;
}

export function useOptionalTenantContext(): TenantSession | null {
  return useContext(TenantContext);
}
